import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { Comparator } from '../../../core/util/comparator'
import { Agrupamento } from '../../../pkw-data/collect/extrato/agrupamento.model'
import { Antecipacao } from '../../../pkw-data/collect/extrato/antecipacao.model'
import { ExtratoDeAntecipacoes } from '../../../pkw-data/collect/extrato/extrato-de-antecipacoes.model'
import { ExtratoDeRecebimentos } from '../../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { ExtratoDeVendas } from '../../../pkw-data/collect/extrato/extrato-de-vendas.model'
import { Extrato } from '../../../pkw-data/collect/extrato/extrato.interface'
import { Recebimento } from '../../../pkw-data/collect/extrato/recebimento.model'
import { Transacao } from '../../../pkw-data/collect/extrato/transacao.model'
import { Venda } from '../../../pkw-data/collect/extrato/venda.model'
import { DadosRelatorio } from '../dados-relatorio'
import { OpcoesRelatorio } from '../opcoes-relatorio.interface'

@Component({
    selector: 'col-relatorio-resumido',
    templateUrl: './relatorio-resumido.component.html',
    styleUrls: ['../relatorio.component.scss']
})
export class RelatorioResumidoComponent implements OnChanges {
    @Input() opcoes: OpcoesRelatorio
    @Input() dados: DadosRelatorio

    vendas: ExtratoDeVendas[]
    recebimentos: ExtratoDeRecebimentos[]
    antecipacoes: ExtratoDeAntecipacoes[]

    ngOnChanges(changes: SimpleChanges) {
        this.handleInputChanges(changes)
    }

    possuiDados() {
        return !!this.dados
    }

    exibirVendas() {
        return this.possuiDados() && this.dados.possuiVendas()
    }

    exibirRecebimentos() {
        return this.possuiDados() && this.dados.possuiRecebimentos()
    }

    exibirAntecipacoes() {
        return this.possuiDados() && this.dados.possuiAntecipacoes()
    }

    valorTaxaOperadora(agrupamento: Agrupamento<Transacao>) {
        if (isAgrupamentoVenda(agrupamento)) {
            return this.valorTaxaOperadoraVenda(agrupamento)
        }
        if (isAgrupamentoRecebimento(agrupamento)) {
            return this.valorTaxaOperadoraRecebimento(agrupamento)
        }
        if (isAgrupamentoAntecipacao(agrupamento)) {
            return this.valorTaxaOperadoraAntecipacao(agrupamento)
        }

        throw Error('Não implementado')
    }

    private valorTaxaOperadoraVenda(agrupamento: Agrupamento<Venda>) {
        return agrupamento.operadora.informaLiquido
            ? agrupamento.transacao.taxaDaOperadora
            : 0
    }

    private valorTaxaOperadoraRecebimento(agrupamento: Agrupamento<Recebimento>) {
        return agrupamento.transacao.taxaDaOperadora
    }

    private valorTaxaOperadoraAntecipacao(agrupamento: Agrupamento<Antecipacao>) {
        return agrupamento.transacao.possuiValorBruto
            ? agrupamento.transacao.taxaDaOperadora
            : 0
    }

    private handleInputChanges(changes: SimpleChanges) {
        if (changes.dados && this.dados) {
            if (this.dados.possuiVendas()) {
                this.vendas = this.dados.vendas.slice()
                this.vendas.forEach(this.ordenarDadosExtrato)
            }
            if (this.dados.possuiRecebimentos()) {
                this.recebimentos = this.dados.recebimentos.slice()
                this.recebimentos.forEach(this.ordenarDadosExtrato)
            }
            if (this.dados.possuiAntecipacoes()) {
                this.antecipacoes = this.dados.antecipacoes.slice()
                this.antecipacoes.forEach(this.ordenarDadosExtrato)
            }
        }
    }

    private ordenarDadosExtrato(extrato: Extrato<Transacao>) {
        extrato.agrupamentos.forEach(agrupamento => {
            agrupamento.detalhes
                .sort((diaA, diaB) =>
                    Comparator.date(diaA.transacao.data, diaB.transacao.data)
                )
                .forEach(dia => {
                    dia.agrupamentos
                        .sort((bandeiraA, bandeiraB) =>
                            Comparator.string(bandeiraA.bandeira, bandeiraB.bandeira)
                        )
                        .reverse()
                        .forEach(bandeira => {
                            bandeira.detalhes
                                .sort((itemA, itemB) =>
                                    Comparator.string(
                                        itemA.transacao.tipoDeVenda,
                                        itemB.transacao.tipoDeVenda
                                    )
                                )
                                .reverse()
                        })
                })
        })
    }
}

function isAgrupamentoVenda(
    agrupamento: Agrupamento<Transacao>
): agrupamento is Agrupamento<Venda> {
    return agrupamento.transacao instanceof Venda
}

function isAgrupamentoRecebimento(
    agrupamento: Agrupamento<Transacao>
): agrupamento is Agrupamento<Recebimento> {
    return agrupamento.transacao instanceof Recebimento
}

function isAgrupamentoAntecipacao(
    agrupamento: Agrupamento<Transacao>
): agrupamento is Agrupamento<Antecipacao> {
    return agrupamento.transacao instanceof Antecipacao
}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/relatorio-resumido/relatorio-resumido.component.ts